

export default function isActive (user) {
    return !!user.active;
}